import React from 'react'
import TextField from '@mui/material/TextField'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { FormHelperText, ListSubheader } from '@mui/material'

const CustomSelect = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'

    function groupedElements() {
        let elements = []

        if (props.groupoptions?.length) {
            props.groupoptions.forEach((optGroup, optGroupIndex) => {
                elements.push(
                    <ListSubheader key={`subheader-${optGroupIndex}`}>
                        {optGroup.head}
                    </ListSubheader>
                )

                optGroup.options.forEach((opt, optIndex) => {
                    elements.push(
                        <MenuItem
                            key={`menuItem-${optIndex}`}
                            value={opt.value || ''}
                            name={opt.value}
                        >
                            {opt.show}
                        </MenuItem>
                    )
                })
            })
        }

        return elements
    }

    return props.native ? (
        <div className={`customSelect ${props.className}`}>
            {props.upperLabel ? <label>{props.label}</label> : null}
            <TextField
                id={props.id}
                select
                size={props.size}
                label={props.inlineLabel ? props.label : ''}
                SelectProps={{
                    native: true,
                }}
                fullWidth
                margin="normal"
                InputLabelProps={{
                    shrink: shrink,
                }}
                variant="outlined"
                disabled={props.disabled}
                name={props.name}
                value={props.value}
                autoFocus={props.autoFocus}
                onChange={props.onChange}
                error={props.error}
                helperText={props.helperText}
            >
                {props.children}
            </TextField>
        </div>
    ) : (
        <>
            {props.native ? (
                <div className={`customSelect ${props.className}`}>
                    <TextField
                        id={props.id}
                        select
                        size={props.size}
                        label={props.label}
                        SelectProps={{
                            native: true,
                        }}
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: shrink,
                        }}
                        variant="outlined"
                        disabled={props.disabled}
                        name={props.name}
                        value={props.value || ''}
                        autoFocus={props.autoFocus}
                        onChange={props.onChange}
                        error={props.error}
                        helperText={props.helperText}
                    >
                        {props.children}
                    </TextField>
                </div>
            ) : (
                <div className={`customSelect nonNative ${props.className}`}>
                    <FormControl fullWidth>
                        <InputLabel
                            id={props.id}
                            className={props.error ? 'Mui-error' : ''}
                        >
                            {props.label}
                        </InputLabel>
                        <Select
                            labelId={props.id}
                            id={props.id}
                            size={props.size}
                            label={props.label}
                            disabled={props.disabled}
                            name={props.name}
                            value={props.value}
                            autoFocus={props.autoFocus}
                            variant={`${
                                props.variant ? props.variant : 'outlined'
                            }`}
                            onChange={props.onChange}
                            error={props.error}
                            helperText={props.helperText}
                        >
                            {props.groupoptions != undefined
                                ? groupedElements()
                                : null}

                            {props.options &&
                                props.options.map((opt, optindex) => (
                                    <MenuItem
                                        key={optindex}
                                        value={opt.value}
                                        name={opt.value}
                                        disabled={
                                            opt.disabled ? opt.disabled : false
                                        }
                                    >
                                        {opt.show}
                                    </MenuItem>
                                ))}
                        </Select>
                        <FormHelperText
                            className={props.error ? 'Mui-error' : ''}
                        >
                            {props.helperText}
                        </FormHelperText>
                    </FormControl>
                </div>
            )}
        </>
    )
}

export default CustomSelect
